import { TestDriveFormData } from "@/schemas/validation/testDriveFormSchema";
import {
  API_ENDPOINTS,
  apiRequest,
  DataReturnType,
  TestDriveRequestCreateDTO,
  SellCarRequestResponseDTO,
  HttpMethods,
} from "@alba-cars/common-modules";

export const createTestDriveRequest = async (data: Omit<TestDriveFormData, "validate" | "toPlain">) => {
  const response = await apiRequest<DataReturnType<SellCarRequestResponseDTO>>(
    API_ENDPOINTS.TestDrive.create.toString(),
    {
      method: HttpMethods.POST,
      body: JSON.stringify(data),
    },
  );
  return response;
};
